import { Component } from "react";
import { Navigate } from "react-router-dom";
import LoginForm from "../components/LoginForm/LoginForm";

class Login extends Component {


    render(){
        

        if (this.props.userAuthStatus) {
            return <Navigate replace to="/control" />;
          } else {
            return (
                <LoginForm handleLogin={this.props.handleLogin}/>
            );
          }

    }
}

export default Login;